@if (visible()) {
  <section class="ai-settings-card" aria-labelledby="ai-settings-card-heading">
    <h2 class="ai-settings-card__heading" id="ai-settings-card-heading">{{ 'AI_AGENTS.ORG_SETTINGS.TITLE' | translate }}</h2>

    @if (loadFailed()) {
      <p class="wn-banner wn-banner--warning ai-settings-card__load-failed" role="alert">
        <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
        <span>{{ 'AI_AGENTS.ORG_SETTINGS.LOAD_FAILED' | translate }}</span>
      </p>
      <button type="button" pButton [outlined]="true" class="ai-settings-card__retry" icon="pi pi-refresh" [label]="'AI_AGENTS.CONNECTIONS.RETRY' | translate" (click)="load()"></button>
    } @else if (settings(); as s) {
      <label class="ai-settings-card__toggle">
        <input
          type="checkbox"
          class="ai-settings-card__writes"
          [checked]="s.writesEnabled"
          [disabled]="!canManage() || saving()"
          (change)="toggleWrites($event)"
        />
        <span class="ai-settings-card__label">{{ 'AI_AGENTS.ORG_SETTINGS.AI_WRITES_ENABLED' | translate }}</span>
      </label>
      <p class="ai-settings-card__hint">{{ 'AI_AGENTS.ORG_SETTINGS.AI_WRITES_ENABLED_HINT' | translate }}</p>
      <label class="ai-settings-card__toggle">
        <input
          type="checkbox"
          class="ai-settings-card__sensitive"
          [checked]="s.sensitiveDataEnabled ?? true"
          [disabled]="!canManage() || saving()"
          (change)="toggleSensitive($event)"
        />
        <span class="ai-settings-card__label">{{ 'AI_AGENTS.ORG_SETTINGS.AI_SENSITIVE_ENABLED' | translate }}</span>
      </label>
      <label class="ai-settings-card__toggle">
        <input
          type="checkbox"
          class="ai-settings-card__usage"
          [checked]="s.usageTrackingEnabled"
          [disabled]="!canManage() || saving()"
          (change)="toggleUsageTracking($event)"
        />
        <span class="ai-settings-card__label">{{ 'AI_AGENTS.ORG_SETTINGS.AI_USAGE_TRACKING' | translate }}</span>
      </label>
      <p class="ai-settings-card__hint">{{ 'AI_AGENTS.ORG_SETTINGS.AI_USAGE_TRACKING_HINT' | translate }}</p>
      <p class="ai-settings-card__hint">{{ 'AI_AGENTS.ORG_SETTINGS.AI_USAGE_TRACKING_OFF_NOTE' | translate }}</p>
      @if (!canManage()) {
        <p class="ai-settings-card__read-only">{{ 'AI_AGENTS.ORG_SETTINGS.READ_ONLY' | translate }}</p>
      }
      @if (error(); as message) {
        <p class="wn-banner wn-banner--danger ai-settings-card__error" role="alert">
          <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
          <span>{{ message }}</span>
        </p>
      }
    } @else {
      <p class="ai-settings-card__hint" role="status">{{ 'AI_AGENTS.LOADING' | translate }}</p>
    }
  </section>
}
